// import '@babel/polyfill'
import Vue from 'vue';
import './plugins/vuetify'
import axios, { AxiosRequestConfig } from 'axios'
import { sync } from 'vuex-router-sync'
import vuetifyToast from 'vuetify-toast';
import App from './AppRoot.vue'
import router from './router';
import store from './store';
import VueSplitPane from 'vue-splitpane'
import VConfirmDialog from 'vuetify-confirm-dialog'
import DateHelper from '@/util/DateHelper';
// import 'material-design-icons/iconfont/material-icons.css'
// import 'typeface-roboto/index.css'
import AppEvents from './AppEvents';
import Routes from './Routes';
import GoogleMaps from '@/plugins/googlemaps/index';
import applicationInsights from './application-insights';

Vue.config.productionTip = false;
Vue.config.devtools = true;
Vue.config.performance = true

axios.interceptors.request.use((config: AxiosRequestConfig) => {
  // add auth token
  const authToken = store.getters['auth/authToken'];
  if (authToken) {
    config.headers.Authorization = `Bearer ${authToken}`;
  }
  // add client version header
  config.headers['X-Client-Version'] = store.getters['app/version'];
  return config;
}, (err: any) => {
  // console.log("REQUEST INTERCEPT: ERROR CAUGHT: ", err);
  return Promise.reject(err);
});

axios.interceptors.response.use((response: any) => {
  return response;
}, (err: any) => {
  if (err.response && err.response.status === 401) {
    vue.$root.$emit(AppEvents.APP_API_UNAUTHORIZED, null);
    // Got back Unauthorized. We'll need to authenticate again...
    store.dispatch('auth/authLogout');
    router.push(
      { 
        name: Routes.signInRoute.name,
        query: { redirect: (store.state as any).route.fullPath }
      }
    )
  }
  return Promise.reject(err);
});

sync(store, router);

Vue.prototype.$dateHelper = new DateHelper();

Vue.component('split-pane', VueSplitPane);

Vue.use(VConfirmDialog);

Vue.use(new GoogleMaps(), {
  apiKey: process.env.VUE_APP_GOOGLE_API_KEY, 
  // Can also be an object. E.g, for Google Maps Premium API, pass `{ client: <YOUR-CLIENT-ID> }`
  // version: '...', // Optional
  language: 'fi', // Optional
});

Vue.use(applicationInsights, {router});

vuetifyToast.defaultOptions.timeout = 5000;

const vue = new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
